import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import clsx from 'clsx';
import Icon from '../../Icon/Icon';
import useStyles from './Heading.styles';
import SplitContentBySlash from '../../../utils/SplitContentBySlash';
const Heading = (props) => {
    const { isQuotation, heading, headingTag, headingClasses, wrapText, isFlyingFlowers, showLeadingAndTrailingLineBreaks, textColour, } = props;
    const { classes } = useStyles({ textColour });
    const effectiveColor = textColour;
    const isHexColor = effectiveColor === null || effectiveColor === void 0 ? void 0 : effectiveColor.startsWith('#');
    // Helper function to get class names for color styling
    const getColorClassName = () => {
        if (isHexColor || !effectiveColor) {
            return classes.headingColor;
        }
        return '';
    };
    // Helper function to get inline styles
    const getInlineStyle = () => {
        return isHexColor && effectiveColor ? { color: effectiveColor } : undefined;
    };
    // Helper function to get SplitContentBySlash class names
    const getSplitContentClassNames = () => {
        // Extract nested ternary operation for better readability
        let headingColorClass = '';
        if (isFlyingFlowers) {
            if (isHexColor || !effectiveColor) {
                headingColorClass = classes.headingColor;
            }
            else {
                headingColorClass = classes[effectiveColor.toString()] || classes.headingColor;
            }
        }
        else if (!isHexColor) {
            headingColorClass = classes.headingColor;
        }
        // For hex colors when not flying flowers, headingColorClass remains empty string (default)
        return {
            headingColor: headingColorClass,
            headingLine: isFlyingFlowers ? classes.headingLine : classes.newHeading,
        };
    };
    // Create heading element based on conditions
    const headingElement = heading && typeof heading === 'string' && wrapText ? (_jsx(SplitContentBySlash, { content: heading, classNames: getSplitContentClassNames(), style: getInlineStyle(), showLeadingAndTrailingLineBreaks: showLeadingAndTrailingLineBreaks })) : (heading);
    if (!isQuotation) {
        return heading ? (_jsx(Box, { className: clsx(classes.heading, getColorClassName(), ...(headingClasses !== null && headingClasses !== void 0 ? headingClasses : [])), component: headingTag !== null && headingTag !== void 0 ? headingTag : 'div', "data-testId": "heading", children: headingElement })) : null;
    }
    // Helper function to render quotation icon
    const renderQuotationIcon = (isOpen) => (_jsx(Icon, { icon: "format_quote", className: clsx(classes === null || classes === void 0 ? void 0 : classes.quotationMark, getColorClassName(), isOpen ? classes === null || classes === void 0 ? void 0 : classes.openQuote : classes === null || classes === void 0 ? void 0 : classes.closeQuote, classes === null || classes === void 0 ? void 0 : classes.quote), dataTestId: "quotation" }));
    return (_jsxs(Box, { className: clsx(classes === null || classes === void 0 ? void 0 : classes.quoteContainer, isQuotation && (classes === null || classes === void 0 ? void 0 : classes.featureTitle)), children: [isQuotation && renderQuotationIcon(true), heading && (_jsx(Box, { className: clsx(classes.heading, getColorClassName(), classes === null || classes === void 0 ? void 0 : classes.noBottomMargin, ...(headingClasses || [])), component: headingTag !== null && headingTag !== void 0 ? headingTag : 'div', "data-testId": "heading", style: getInlineStyle(), children: headingElement })), isQuotation && renderQuotationIcon(false)] }));
};
export default Heading;
